<template>
  <div>
    <div class="main-1">
      <div class="main-chart-1">
        <div id="chart1" style="width: 48vw;height: 350px;"></div>
      </div>
      <div class="main-chart-2">
        <div class="title">月平均观看次数</div>
        <div class="eductionCount">{{monthData}}次</div>
      </div>
      <div class="main-chart-3">
        <div class="title">年度观看占比</div>
        <div id="chart2" style="width: 19vw;height: 290px;"></div>
      </div>
    </div>
    <div class="main-2">
      <div class="search">
        <div style="display: flex;align-items: center;">
          <p style="width: 4vw">名称</p>
          <el-input v-model="videoName" size="medium" placeholder="请输入视频名称" clearable></el-input>
        </div>
        <div style="display: flex;align-items: center;margin: 0 10px;">
          <p style="width: 4vw">日期</p>
          <el-date-picker size="medium" v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="select"></el-date-picker>
        </div>
        <span class="button" @click="select">查询</span>
      </div>
      <el-table :data="tableData" stripe height="73vh">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
         <el-table-column label="发起角色">
          <template slot-scope="scope">
            <span v-if="scope.row.groupType == 1">企业端</span>
            <span v-else-if="scope.row.groupType == 2">项目端</span>
            <span v-else-if="scope.row.groupType == 3">企业组织</span>
            <span v-else-if="scope.row.groupType == 4">班组</span>
          </template>
        </el-table-column>
         <el-table-column label="视频名称">
          <template slot-scope="scope">
            <span>{{scope.row.videoName}}</span>
          </template>
        </el-table-column>
         <el-table-column label="应观人数">
          <template slot-scope="scope">
            <span>{{scope.row.personsum}}</span>
          </template>
        </el-table-column>
         <el-table-column label="未观人数">
          <template slot-scope="scope">
            <span>{{scope.row.personCount}}</span>
          </template>
        </el-table-column>
         <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{scope.row.createDate}}</span>
          </template>
        </el-table-column>
         <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="table-button" style="color: #8EA3CE;" @click="toLook(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import base from '../../../../untils/base'
  import myHttp from '../../../../untils/port'
  import util from '../../../../untils/util'
  export default {
    data() {
      return {
        videoName: '',
        date: '',
        projectId: '',
        pageNum: 1,
        pageSize: 20,
        total: 0,
        tableData: [],
        chartDate: [],
        weekDate: [],
        monthData: '',    // 月观看次数
        yearData: [],   
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      this.getData()
      this.getMonthData()
    },
    mounted() {
      this.getWeekData()
      this.getYearData()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },

      getData(){
        myHttp.projectExamVideoProjectListNew({
          videoName: this.videoName,
          createDate: this.date,
          projectId: this.projectId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data.examVideoProjectList.list
            for(let i=0;i<data.length;i++){
              data[i].index = (this.pageNum - 1) * this.pageSize + 1 + i
            }
            this.tableData = data
            this.total = resp.data.data.examVideoProjectList.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      getWeekData(){
        const endDate = util.myTime.getCurTime()
        const startDate = util.myTime.formatTime(new Date().getTime() - (1000 * 60 * 60 *24 * 7), 'yyyy-MM-dd')
        myHttp.getCountByVideoId({
          projectId: this.projectId,
          videoId: '',
          startDate: startDate,
          endDate: endDate
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data.data
            data.forEach(item => {
              this.chartDate.push(item.clickDate.slice(5))
              this.weekDate.push(item.count)
            })
            this.initChart1()
          }
        })
      },

      getMonthData(){
        const date = util.myTime.getCurMonth()
        myHttp.getCountMonthByVideoId({
          projectId: this.projectId,
          Date: date
        }).then(resp => {
          if(resp.data.code === 200){
            this.monthData = resp.data.data
          }
        })
      },

      getYearData(){
        const date = util.myTime.getYear()
        myHttp.getCountYearByVideoId({
          projectId: this.projectId,
          date: date
        }).then(resp => {
          if(resp.data.code === 200){
            this.yearData = resp.data.data.data
            this.initChart2()
          }
        })
      },

      initChart1(){
        let myChart1 = this.$echarts.init(document.querySelector('#chart1'))
        myChart1.setOption({
          grid: {      //  设置位置
            top: '15%',
            left: '5%',
            right: '5%',
            bottom: '8%',
          },
          xAxis: {
            data: this.chartDate,
            axisTick: {
              show: false   // x轴的刻度
            },
            axisLabel: {   // x轴文字的配置
              textStyle: {  
                color: '#9E9E9E',
                fontSize: '14px'
              }
            },
            axisLine: {
              lineStyle: {        //自定义x轴线的颜色和阴影
                color: '#0FA2F1',
                shadowColor: '#0F9FED',
                shadowBlur: 6,
                width: 2
              }
            },
            splitLine: {   // x轴背景线条的配置
              show: true,
              interval: 6,
              lineStyle: {
                color: '#0FA2F1',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            axisLabel: {     // y轴文字的配置
              textStyle: {
                color: '#9E9E9E',
                fontSize: '14px'
              }
            },
            axisLine: {
              show: true,    // 打开y轴刻度线
              lineStyle: {
                color: '#0FA2F1',
                width: 2,
                type: 'solid',
                shadowColor: '#0F9FED',
                shadowBlur: 6,
              }
            },
            splitLine: {     // y轴背景线条的配置
              show: true,
              lineStyle: {
                color: '#0FA2F1',
                type: 'dashed'
              }
            },
          },
          tooltip: {   // 提示框
            position: 'top',    // 提示框在顶部
            borderColor: '#3ACDFE',    //  提示框的边框颜色
            formatter: function(params){
              return `
                <p style="font-size: 16px">播放时长</p>
                <p style="font-size: 16px">${params.data}min</p>
              `
            },
            textStyle: {
              color: '#0FA2F1'
            }
          },
          series: [{
            type: 'bar',
            barWidth: 26,
            color: '#0FA2F1',
            data: this.weekDate,
            // itemStyle: {
            //   normal: {
            //     color: new this.$echarts.graphic.LinearGradient(0,1,0,0,
            //     [{
            //       offset: 0,
            //       color: '#D8D8D8'
            //     },{
            //       offset: 1,
            //       color: '#0FA2F1'
            //     }]
            //     )
            //   }
            // }
          }]
        })
      },

      initChart2(){
        let myChart2 = this.$echarts.init(document.querySelector('#chart2'))
        myChart2.setOption({
          series: [
            {
              type: 'pie',
              radius: [0, 120],
              roseType: 'radius',   //是否展示成南丁格尔图 'radius' 扇区圆心角展现数据的百分比，半径展现数据的大小。'area' 所有扇区圆心角相同，仅通过半径展现数据大小。
              label: {
                shoe: true,
                position: 'inner',
                color: '#0787FF',
                formatter: function(data){
                  return `
                   ${data.name}
                   ${data.value}
                  `
                }
              },
              color: ['#3AB2F2', '#8ED3F8', '#9FC2D5', '#0077B8'],
              data: [
                { value: this.yearData[0].number, name: '第一季度' },
                { value: this.yearData[1].number, name: '第二季度' },
                { value: this.yearData[2].number, name: '第三季度' },
                { value: this.yearData[3].number, name: '第四季度' },
              ],
            },
          ]
        })
      },
      
      toLook(row){
        this.$router.push({
          path: '/newLookVideo',
          query: {
            videoId: row.videoId,
            entId: row.entId
          }
        })
      }
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  cursor: pointer;
}
.main-1{
  display: flex;
  justify-content: space-between;
  height: 350px;
  margin-bottom: 8px;
}
.main-1> div{
  border-radius: 6px;
  background: #FFFFFF;
}
.main-chart-1{
  width: 55%;
}
.main-chart-2{
  width: 22%;
}
.main-chart-3{
  width: 22%;
}
.main-2{
  /* min-height: 80vh; */
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.search{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 18px;
  border-bottom: 2px solid #D8D8D8;
}
.title{
  height: 56px;
  padding: 17px 16px;
  font-size: 16px;
  color: #666666;
  text-align: left;
  border-bottom: 2px solid #E7E7E7;
}
.eductionCount{
  position: relative;
  width: 220px;
  height: 257px;
  margin: 0 auto;
  background: url('../../../../assets/image/new/eductionCount.png') no-repeat 0 -15px;
  line-height: 257px;
  text-align: center;
  font-size: 40px;
  color: #409BCB;
}
</style>